import { createAction } from 'redux-actions'
import queryString from 'query-string'
import * as contentful from 'contentful'
import { get, find } from 'lodash'

import { actionCreators as api } from 'reduxBits/api'

export const RECEIVE_ENTRY = 'get entry'
export const REQUEST_ENTRY = 'request entry'

const receiveEntry = createAction(RECEIVE_ENTRY)
const requestEntry = createAction(REQUEST_ENTRY)

let client

const fetchCarFaxLink = (entry) => (dispatch, getState) => {
  const state = getState()
  const adId = get(queryString.parse(state.router.location.search), 'adId')

  const options = {
    include: ['partner_placements'],
    status: ['active'],
  }
  if (adId) {
    return dispatch(
      api.fetch(`search_bff/v1/content/${adId}?${queryString.stringify(options)}`, {}),
    ).then(
      (data) => {
        if (data.ok) {
          const response = data.textOrJson
          const carfaxPlacement = find(
            get(response.data, 'partnerPlacements'),
            (placement) => placement.id === 'carfax',
          )
          const actionUrl = get(carfaxPlacement, 'actionUrl')
          const label = get(carfaxPlacement, 'label')

          if (actionUrl) {
            entry.content = entry.content.replace(/!!!carfaxlink!!!/g, actionUrl)
          }

          if (label) {
            entry.content = entry.content.replace(/!!!carfaxlabel!!!/g, label)
          }

          dispatch(receiveEntry(entry))
        }
        dispatch(receiveEntry(entry))
      },
      (error) => {
        dispatch(receiveEntry(error))
      },
    )
  }
  return dispatch(receiveEntry(entry))
}

const fetchEntry = (url) => (dispatch, getState) => {
  const state = getState()

  if (!client) {
    client = contentful.createClient({
      space: get(state, 'config.contentful.communication.id'),
      accessToken: get(state, 'config.contentful.communication.deliveryToken'),
    })
  }
  dispatch(requestEntry())

  client
    .getEntries({
      'fields.url': url,
      content_type: 'infoPages',
    })
    .then((entries) => {
      const entry = get(entries, 'items[0].fields')

      if (
        entry.content.indexOf('!!!carfaxlabel!!!') > -1 ||
        entry.content.indexOf('!!!carfaxlink!!!') > -1
      ) {
        dispatch(fetchCarFaxLink(entry))
      } else {
        dispatch(receiveEntry(entry))
      }
    })
    .catch((error) => dispatch(receiveEntry(error)))
}

export const actionCreators = {
  fetchEntry,
}
